import { Injectable } from '@rxdi/core';
import { async, TemplateResult } from '@rxdi/lit-html';
import { BehaviorSubject, iif, of, Subject } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class ModalService {
  modalOpened: Subject<boolean> = new Subject();
  template: BehaviorSubject<string> = new BehaviorSubject('');

  showModal(template?: TemplateResult) {
    if (template) {
      this.template.next(template.getHTML());
    }
    this.modalOpened.next(true);
  }
  closeModal() {
    this.modalOpened.next(false);
  }

  getModalTemplate(template: TemplateResult) {
    return async(this.modalOpened.pipe(mergeMap((v) => iif(() => v, of(template), of('')))));
  }
}
